module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAG1BMVEUAAACWlpaSkpKSkpKRkZGSkpK/v7+SkpKRkZHyDbobAAAACHRSTlMAIOGTQb8EwCFGfxsAAABcSURBVAjXYxAVYIAA4QSGCkUIk1HDgEGoCSwBooF8kASIgghASIgIlIAIgTFUKVgYKuEEEoZKdACFocCjw4EBQxyhHmEOmvkIe1Hcg+xOFPdbwP0VwJAMc4moAAC48xOh5oS3QwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/ballon-close.png
// module id = 872
// module chunks = 0